import { render, staticRenderFns } from "./CargoCrudKanban.vue?vue&type=template&id=743042dc&scoped=true"
import script from "./CargoCrudKanban.vue?vue&type=script&lang=js"
export * from "./CargoCrudKanban.vue?vue&type=script&lang=js"
import style0 from "./CargoCrudKanban.vue?vue&type=style&index=0&id=743042dc&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "743042dc",
  null
  
)

export default component.exports